import {User} from '@hconnect/apiclient'
import {ControlledToggle} from '@hm/fundamental'
import {Controller, FieldValues} from 'react-hook-form'
import {useLocation} from 'react-router'

import {useTranslation} from '../../../hooks/useTranslation'
import {UserInformationInputSkeleton} from '../Skeleton/UserInformationInputSkeleton'

import {UserInformationProps} from './types'

type TestUserInputProps<T extends FieldValues> = UserInformationProps<T> & {
  loggedInUserProfile?: User | null
}

export const TestUserInput = <T extends FieldValues>({
  readonlyMode,
  formMethods,
  isLoading,
  name,
  loggedInUserProfile
}: TestUserInputProps<T>) => {
  const {pathname} = useLocation()
  const isInternal = loggedInUserProfile?.isInternal
  const {t} = useTranslation()

  if (isLoading) {
    return <UserInformationInputSkeleton />
  }

  if (readonlyMode || !isInternal || pathname.includes('managePilot')) {
    return null
  }

  return (
    <Controller
      name={name}
      control={formMethods.control}
      render={({field}) => (
        <ControlledToggle
          checked={field.value}
          name="test-user-toggle"
          label={t('userInformationForm.thisIsATestUser')}
          onChange={field.onChange}
          data-cy="label-test-user"
        />
      )}
    />
  )
}
